import { all, put, takeLatest } from "redux-saga/effects";
import { getComplaintsSummaryCount } from "../../Services/database";
import { setErrorStatus } from "../status/action";
import { COMPLAINT_SOURCE_TYPES } from "../../Utils/Constants/Constants";
import store from "../store";

function* getComplaintsCountWorker(action) {
  try {
    yield put({ type: "SET_COMPLAINTS_LOADING", payload: { loading: true } });
    const accessToken = store.getState().auth.data.accessToken;

    const now = Date.now();
    const from = action?.payload?.from ?? 0;
    const to = action?.payload?.to ?? now;

    const allowedZones = action?.payload?.allowedZones;
    // Firestore caps an "in" clause at 30 values.
    const zones = Array.isArray(allowedZones) && allowedZones.length > 0
      ? allowedZones.slice(0, 30)
      : null;
    const baseFilter = [
      "createdAt", ">=", from,
      "createdAt", "<=", to,
      ...(zones ? ["location.zone", "in", zones] : [])
    ];

    const [customerSupportCount, publicCount, independentEngineerCount] =
      yield Promise.all(
        COMPLAINT_SOURCE_TYPES.map((type) =>
          getComplaintsSummaryCount([...baseFilter, "issuedBy.type", "==", type], accessToken)
        )
      );

    yield put({
      type: "SET_COMPLAINTS_COUNT_DATA",
      payload: {
        count: {
          total: customerSupportCount + publicCount + independentEngineerCount,
          customerSupport: customerSupportCount,
          public: publicCount,
          independentEngineer: independentEngineerCount,
        },
        range: { from, to }
      }
    });

    yield put({ type: "SET_COMPLAINTS_LOADING", payload: { loading: false } });
  } catch (error) {
    yield put({ type: "SET_COMPLAINTS_LOADING", payload: { loading: false } });
    setErrorStatus(error);
  }
}

export default function* complaintsWatcher() {
  yield all([
    takeLatest("GET_TODAY_COMPLAINT_COUNT", getComplaintsCountWorker),
    takeLatest("GET_COMPLAINTS_COUNT", getComplaintsCountWorker)
  ]);
}
